// extracted by mini-css-extract-plugin
export default {"wrapper":"Shortcuts_wrapper__04Edr","layout":"Shortcuts_layout__x9feZ","card":"Shortcuts_card__LxXiL","title":"Shortcuts_title__mmBKI","command":"Shortcuts_command__j9-A7"};